import { InjectionToken } from '@angular/core';
import { IProjectsService } from '../../interfaces/services/projects-service.interface';

export const PROJECTS_SERVICE = new InjectionToken<IProjectsService>('ProjectsService');
